import Collection from 'features/media/components/organisms/Collection/Collection';

export default Collection;
